<template>
  <FeatureDetailPage feature-key="programs" />
</template>
